import React from "react";

const HomeDocs = () => {
  return (
    <div className="max-w-6xl mx-auto p-6">
      {/* Intro Section */}
      <div className="bg-white p-6 rounded-2xl shadow-md shadow-gray-200 mb-6">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">What is the Five Prayer Plugin?</h2>
        <p className="text-lg text-gray-700 text-center">
          The <strong>Five Prayer Plugin</strong> is a dedicated solution for Muslim WordPress websites that need to display 
          accurate daily prayer times. It integrates seamlessly with your site, offering an easy-to-use interface for showing 
          Salah times based on location and calculation methods.
        </p>
      </div>

      {/* Video Section */}
      <div className="w-full flex justify-center mb-6">
        <iframe
          width="100%"
          height="500"
          src="https://www.youtube-nocookie.com/embed/c7MVPIepyVI?si=WTzfLgG8gUzhH1cV"
          title="Five Prayer Plugin Introduction"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="rounded-lg shadow-md"
        ></iframe>
      </div>
    </div>
  );
};

export default HomeDocs;
